const config = {
  rowSelection: false,
  columns: [
    {
      title: '核销单号',
      dataIndex: 'billNo',
      width: 160,
    },
    {
      title: '核销时间',
      dataIndex: 'verifiedDate',
      itemType: 'dateTime',
      width: 160,
    },
    {
      title: '核销金额',
      dataIndex: 'verifiedAmount',
      width: 100,
      render: 'verifiedAmountRender',
    },
    {
      title: '源单类型',
      dataIndex: 'sourceBillTypeName',
      width: 180,
      render: 'sourceTypeRender',
    },
    {
      title: '收款类型',
      dataIndex: 'sourceTypeName',
      width: 180,
      render: 'sourceTypeNameRender',
    },
    {
      title: '合同类型',
      dataIndex: 'budgetVersionDesc',
      width: 180,
      render: 'budgetVersionDescRender',
    },
    {
      title: '合同金额',
      dataIndex: 'budgetContractAmount',
      width: 120,
      render: 'budgetContractAmountRender',
    },
    {
      title: '单号',
      dataIndex: 'sourceCode',
      width: 180,
      render: 'sourceCodeRender',
    },
    {
      title: '操作',
      dataIndex: 'actions',
      render: 'renderOperate',
      width: 100,
    },
  ],
  search: [
    {
      name: 'sourceBillTypeList',
      label: '源单类型',
      itemType: 'select',
      data: 'sourceBillTypeList',
      labelKey: 'description',
      key: 'key',
    },
    {
      name: 'sourceTypeList',
      label: '收款类型',
      itemType: 'select',
      data: 'receiptTypeList',
      labelKey: 'name',
      key: 'priKey',
    },
    {
      name: 'contractTypeList',
      label: '合同类型',
      itemType: 'select',
      data: 'contractTypeList',
      labelKey: 'desc',
      key: 'code',
    },
    {
      name: 'verifiedDate',
      label: '核销时间',
      itemType: 'autoDate',
    },
  ],
  footer: [
  ]
}

export default config
